// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f"}[chunkId] || chunkId) + "." + {"199":"0390e03bdf6a258d","316":"2cf0d2625664d51a","501":"7e63d871e474c3ee","931":"0fa1bf896962082c"}[chunkId] + ".js";
};